
function Order() {
  return (
    <>
    <section class="section hero is-light">
      <h1 class="title">Solicitação de Cotação</h1>
      <h2 class="subtitle">
        Preencha os campos abaixo para iniciarmos o processo de analise
      </h2>
    </section>
    <section class="hero xis-light is-fullheight pt-5">

    <div class="container" style={{padding: "30px"}}>
      <h1 class="title is-4">Contato</h1>
      <div class="field pl-5">
        <label class="label">Nome</label>
        <div class="control">
          <input class="input" type="text" placeholder="Nome"/>
        </div>
      </div>

      <div class="field pl-5">
        <label class="label">Email</label>
        <div class="control">
          <input class="input" type="email" placeholder="email@email.com"/>
        </div>
      </div>

      <div class="field pl-5">
        <label class="label">Telefone</label>
        <div class="control">
          <input class="input" type="email" placeholder="Telefone"/>
        </div>
      </div>

      <h1 class="title is-4" style={{marginTop: "40px"}}>Conta</h1>
      <div class="columns pl-5">
        <div class="column">
          <div class="field">
          <label class="label">Fatura</label>
          <div class="control">
            <div class="file has-name">
              <label class="file-label">
                <input class="file-input" type="file" name="resume" />
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fas fa-upload"></i>
                  </span>
                  <span class="file-label">Selecione um arquivo</span>
                </span>
                <span class="file-name"> Fatura.pdf </span>
              </label>
            </div>
          </div>
        </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">Tipo de Energia contratada no mercado livre</label>
            <div class="control">
              <div class="select">
                <select style={{width: "400px"}}>
                  <option>Convencional</option>
                  <option>Incentivada 50%</option>
                  <option>Incentivada 100%</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="columns pl-5">
        <div class="column">
          <div class="field">
            <label class="label">Ano de início</label>
            <div class="control">
              <div class="select">
                <select style={{width: "400px"}}>
                  <option>2026</option>
                  <option>2027</option>
                  <option>2028</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="column">
        <div class="field">
            <label class="label">Ano de fim</label>
            <div class="control">
              <div class="select">
                <select style={{width: "400px"}}>
                  <option>2026</option>
                  <option>2027</option>
                  <option>2028</option>
                  <option>2029</option>
                  <option>2030</option>
                  <option>2031</option>
                  <option>2032</option>
                  <option>2033</option>
                  <option>2034</option>
                  <option>2035</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="field is-grouped">
        <div class="control">
          <button class="button is-link">Solicitar</button>
        </div>
      </div>
    </div>

      <div class="container p-5 is-hidden">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Nome</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input xis-danger" type="text" placeholder="Nome"/>
              </div>
              {/* <p class="help is-danger">
                This field is required
              </p> */}
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Email</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input xis-danger" type="email" placeholder="Email"/>
              </div>
              {/* <p class="help is-danger">
                This field is required
              </p> */}
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Telefone</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <input class="input xis-danger" type="text" placeholder="Telefone"/>
              </div>
              {/* <p class="help is-danger">
                This field is required
              </p> */}
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Fatura</label>
          </div>
          <div class="field-body">
            <div class="file has-name is-right">
              <label class="file-label">
                <input class="file-input" type="file" name="resume" />
                <span class="file-cta">
                  <span class="file-icon">
                    <i class="fas fa-upload"></i>
                  </span>
                  <span class="file-label"> Choose a file… </span>
                </span>
                <span class="file-name"> Fatura.pdf </span>
              </label>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Periodo</label>
          </div>
          <div class="field-body">
            <div class="field">
              <p class="control is-expanded has-icons-left">
                <input class="input" type="text" placeholder="Ano Inicio"/>
                <span class="icon is-small is-left">
                  <i class="fas fa-user"></i>
                </span>
              </p>
            </div>
            <div class="field">
              <p class="control is-expanded has-icons-left has-icons-right">
                <input class="input is-success" type="text" placeholder="Ano Final"/>
                <span class="icon is-small is-left">
                  <i class="fas fa-envelope"></i>
                </span>
                <span class="icon is-small is-right">
                  <i class="fas fa-check"></i>
                </span>
              </p>
            </div>
          </div>
        </div>

        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">Tipo de Energia contratada no mercado livre</label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <div class="select">
                  <select>
                    <option>Select dropdown</option>
                    <option>With options</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="field is-horizontal mt-5">
          <div class="field-label">
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <button class="button xis-primary">
                  Solicitar
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
    </>
  );
}

export default Order;
